import React from 'react';
import ChartLabelRender, {ChartLabelProps} from './ChartLabelRender';

export const ChartLabel =({...props}:ChartLabelProps):JSX.Element=>{
	return <ChartLabelRender {...props}/>;
};